import styled from "styled-components"
import media from "styled-media-query"

export const Container = styled.div`
  width: 30rem;
  height: 35rem;
  margin-bottom: 5rem;

  display: flex;
  flex-direction: column;

  z-index: 20;

  &:first-of-type {
    margin-top: 3rem;
  }

  ${media.greaterThan("medium")`
    margin-bottom: 0;
    &:first-of-type {
      margin-top: 0;
    }
    &:not(:last-of-type) {
      margin-right: 10rem;
    }
  `}
`

export const Icons = styled.figure`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  height: 6rem;
  width: 100%;

  img {
    object-fit: contain;
  }
`
export const Card = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  width: 100%;

  padding: 4rem 3rem 2.5rem;

  border-radius: 2rem;
  background-color: #fff;

  p {
    color: #666;
    font-size: 1.3rem;
    &:not(:last-of-type) {
      margin-bottom: 2rem;
    }
  }
`
export const Title = styled.h2`
  margin-bottom: 2rem;

  color: #ff5c00;
  font-size: 2.2rem;
`

export const Content = styled.div`
  flex: 1;
`
